import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { HandHeart } from 'lucide-react';
import { giveOptions } from '@/content/public-site-content';

export default function GivePage() {
  return (
    <div className="mx-auto w-full max-w-6xl space-y-8 px-4 py-6 sm:px-6 lg:px-8 lg:py-10">
      <section className="rounded-[2rem] border border-border/70 bg-card/90 p-8 shadow-sm">
        <div className="space-y-4 text-center">
          <Badge variant="outline" className="mx-auto w-fit border-primary/30 bg-primary/5">
            <HandHeart className="mr-1 h-3 w-3 text-primary" />
            Give
          </Badge>
          <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">Give</h1>
          <p className="mx-auto max-w-2xl text-muted-foreground">
            Thank you for partnering with us. Choose the giving option that fits what you want to support.
          </p>
        </div>
      </section>

      <section className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
        {giveOptions.map((option) => (
          <Card key={option.title} className="overflow-hidden border-border/70 bg-card/95 py-0 shadow-sm">
            <div className="h-56 overflow-hidden">
              <img src={option.image} alt={option.title} className="h-full w-full object-cover" />
            </div>
            <div className="flex h-full flex-col gap-4 p-6">
              <div className="space-y-2">
                <h2 className="text-xl font-semibold">{option.title}</h2>
                <p className="text-sm leading-6 text-muted-foreground">{option.description}</p>
              </div>
              <div className="mt-auto flex flex-wrap gap-2">
                {option.actions.map((action) => (
                  <Button key={action.label} size="sm" asChild>
                    <a href={action.href} target="_blank" rel="noopener noreferrer">
                      {action.label}
                    </a>
                  </Button>
                ))}
              </div>
            </div>
          </Card>
        ))}
      </section>
    </div>
  );
}
